module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('section', {
    staticClass: "content",
    attrs: {
      "role": "main",
      "aria-label": "תוכן",
      "id": "RhythmAudition"
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgFront",
    attrs: {
      "src": "photos/ensemble/aa1.jpg",
      "alt": "רישום לאנסמבל"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "auditionLogo"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/logo.png",
      "alt": "החצר"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "auditionLogoSubtitle"
  }, [_vm._v("אנסמבל קולי")])]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text1header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text2header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text2)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text3header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.ensamble_text3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('div', {
    staticClass: "talkWithUs",
    on: {
      "click": function($event) {
        _vm.showDialog = true
      }
    }
  }, [_vm._v("רוצים לדבר איתנו?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "textbox textbox-right textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox-text"
  }, [_c('Audition', {
    attrs: {
      "auditionType": "Ensemble"
    }
  })], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider",
    attrs: {
      "id": "FAQSdivider"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content double-content2",
    attrs: {
      "id": "FAQS"
    }
  }, [_c('div', {
    staticClass: "fill double-content2"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgFront",
    attrs: {
      "src": "photos/ensemble/aa2.jpg",
      "alt": "שאלות נפוצות"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("שאלות נפוצות")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('FAQ', {
    key: _vm.faq
  })], 1)], 1)])])])]), _vm._v(" "), (_vm.showDialog) ? _c('TalkToMe', {
    attrs: {
      "auditionType": "Ensemble"
    },
    on: {
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b4dec9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Ensemble.vue
// module id = 119
// module chunks = 0